import * as AUTH_CONFIG from './cognito.json';

type Stage = 'dev' | 'production' | 'staging';

/**
 * Convex throws an error if ENV variables are tried to be used in any imported files.
 * See https://discord.com/channels/1019350475847499849/1252573078848798721/1252574564479668236
 * To work around this, we wrap this logic in a function.
 */
export const getCognitoConfig = () => {
  // Set these values in a `.env.local` file in the root of the consuming application.
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const stage = (process.env.VITE_STAGE || process.env.EXPO_PUBLIC_STAGE) as Stage | undefined;

  // Throw instead of defaulting to 'dev' to avoid accidentally using dev settings.
  if (!stage) {
    throw new Error('VITE_STAGE or EXPO_PUBLIC_STAGE environment variable is not set');
  }

  console.log(`[auth] stage: ${stage}`);

  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: Ignore
  const cognitoConfig = AUTH_CONFIG[stage];
  if (!cognitoConfig) {
    throw new Error(`Unrecognized STAGE value: ${stage}`);
  }

  return {
    Auth: {
      Cognito: cognitoConfig,
    },
  };
};
